// fieldvalidator.js

export const isValidTZ = (tz) => {
  if (!/^\d{5,9}$/.test(tz)) return false;

  tz = tz.padStart(9, "0");
  let sum = 0;

  for (let i = 0; i < 8; i++) {
    let num = Number(tz[i]) * ((i % 2) + 1);
    if (num > 9) num = Math.floor(num / 10) + (num % 10);
    sum += num;
  }

  const checkDigit = (10 - (sum % 10)) % 10;
  return checkDigit === Number(tz[8]);
};

export const isValidHetPey = (value) => {
  if (!/^\d{9}$/.test(value)) return false;
  return true;
};

export const validatePhone = (value) => {
  if (!value) return "";
  const cleaned = value.replace(/\s|-/g, "");
  const isValid = /^\d{10}$/.test(cleaned);
  return isValid ? "" : "Invalid phone number";
};
